export default {
      id: "insurance-note-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#insurance-note",
      toString: function () {
        return this.url;
      }
    }